module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/q01_1_pc_bc7c9d8a117b16b96dbe9603c67d00d3.png";